import styled from "styled-components";
import { MenuItem } from '@material-ui/core';

export const StyledListButton = styled.button`
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  color: #212121;
  position: relative;
  background: none;
  border: 0;
  padding: 12px 22px;
  outline: 0;
  cursor: pointer;
  font-family: 'Roboto';
  width: 100%;
  text-align: left;
  transition: all 250ms;
  text-transform: uppercase;

  &:hover {
    color: #3994de;
  }
`;

export const StyledMobileButton = styled.button`
  padding: 0;
  border: 0;
  background: none;
`;

export const StyledMobileMenuItem = styled(MenuItem)`
  && {
    padding-top: ${props => (props.isTitle ? '12px' : 0)};
    padding-bottom: ${props => (props.isTitle ? '12px' : 0)};
    height: 100%;
    button,
    a {
      text-align: left;
      width: 100%;
      padding-top: 12px;
      padding-bottom: 12px;
    }
  }
`;